import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TerminalSyncLogModel } from './model/terminal-sync-log.model'; 
import { RequestData } from 'src/app/common/models/request-data.model';
@Injectable({
  providedIn: 'root'
})
export class TerminalSyncLogService {
  constructor(private http: HttpClient) { }

  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/terminal-sync-log/get', requestData);
  }

  getShopList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/common/shop/get', requestData);

  }

}